module.exports = __webpack_public_path__ + "img/title.58f8905f.png";